import { Location } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from 'primeng/breadcrumb';

@Component({
  selector: 'app-admin-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() breadcrumbs: breadcrumb[] = []
  @Input() links: link[] = []
  @Input() header: string = ''
  @Input() stats: stat[] = [];
  @Input() queryParams: any = {};
  @Input() showBreadCrums: boolean = true;

  @Input() noHome: boolean = false

  @Output() backClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private router: Router, private location: Location) { }

  ngOnInit() {
    this.breadcrumbs = this.breadcrumbs?.filter((b: breadcrumb) => {
      if (b.visible != undefined || b.visible != null) {
        return b.visible;
      }
      return true;
    });
    this.links = this.links.filter((l: link) => {
      if (l.visible != undefined || l.visible != null) {
        return l.visible;
      }
      return true;
    });
  }

  onBackClicked(item: link) {
    console.log('ITEM CLICKED',item)
    if (!!item.link) {
      this.router.navigate([item.link], {queryParams:!!item.queryParams ? item.queryParams : {}});
      return;
    }
    this.location.back()
    // const backLink = this.links.find(link => link.click === true);
    // if (backLink) {
    //   console.log("BackClick");
    //   this.backClicked.emit();
    // } else {
    // }
  }
}


export class link {
  name: string = '';
  icon: string = '';
  link: string = '';
  click?: boolean = false;
  visible?: boolean = true;
  queryParams?: any = '';
}

export class breadcrumb {
  name: string = '';
  link: string = '';
  visible?: boolean = true
  queryParams?: any = '';
}

export interface stat {
  name: string,
  number: number,
  icon: string
}